import '../assets/Overlay.css';
import { defineComponent, useCssVars, computed, openBlock, createElementBlock, withModifiers, unref } from 'vue';
import { d as debounce } from './debounce.CJgNZ1TL.js';
import { A as AgentActionKind } from './maps.nxkzRTum.js';
import { o as useStore } from './useStore.B0k3KXLh.js';

const _hoisted_1 = ["closeOnClick"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Overlay",
  props: {
    closeOnClickOutside: { type: Boolean }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "7abe1ea7": flipBackground.value
    }));
    const store = useStore();
    const props = __props;
    const flipBackground = computed(() => store?.rtl ? "scaleX(-1)" : "none");
    const onClickBack = debounce(() => {
      if (props.closeOnClickOutside) {
        store?.handlers.callHandler(AgentActionKind.Dismiss);
      }
    }, 200, { leading: true, trailing: false });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "thn--tool-overlay",
        onMousedown: _cache[0] || (_cache[0] = withModifiers(
          //@ts-ignore
          (...args) => unref(onClickBack) && unref(onClickBack)(...args),
          ["left"]
        )),
        onClick: _cache[1] || (_cache[1] = //@ts-ignore
        (...args) => unref(onClickBack) && unref(onClickBack)(...args)),
        closeOnClick: props.closeOnClickOutside
      }, null, 40, _hoisted_1);
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Overlay.vue_vue_type_style_index_0_lang.ClKc0F1i.js.map
